export default {
  name: 'PcColumnLayout',
  data() {
    return {
      className: 'app__column-layout',
    };
  },
  props: {
    columns: {
      type: [String, Number],
      default: '3',
    },
  },
  computed: {
    columnClassName() {
      return `${this.className}__column`;
    },
    columnCountClassName() {
      return `${this.columnClassName}--${this.columns}`;
    },
  },
};
